import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../_utils/modal';
import Button from '../../_common/button';
import classNames from 'classnames';
import { usePrintsOrderStore } from '../stores';

const PhotoRemoveAllButton = ({
  disabled,
  finish,
  multipleFinishesPerOrder,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const removeAllPhotos = usePrintsOrderStore((state) => state.removeAllPhotos);

  const handleClose = () => setIsOpen(false);

  const handleConfirm = () => {
    removeAllPhotos();
    handleClose();
  };

  return (
    <>
      <button
        className={classNames('btn btn-link btn-underline px-0 text-left', {
          'text-muted': disabled,
        })}
        role="button"
        disabled={disabled}
        onClick={() => setIsOpen(true)}>
        {multipleFinishesPerOrder && !!finish
          ? `Remove All ${finish.title + ' '}Photos`
          : 'Remove All Photos'}
      </button>
      <Modal
        className={`mx-2 photo-remove-all-confirmation`}
        maxWidth={500}
        open={isOpen}
        onClose={handleClose}
        title={
          multipleFinishesPerOrder && !!finish
            ? `Remove all ${finish.title} photos?`
            : 'Remove all photos?'
        }
        actions={
          <>
            <Button
              text="Cancel"
              className="btn btn-link"
              data-dismiss="modal"
              type="button"
              aria-label="Cancel without removing all photos"
              onClick={handleClose}
            />
            <Button
              text="Remove"
              className="btn btn-primary btn-remove"
              data-dismiss="modal"
              type="button"
              aria-label="Remove all photos"
              onClick={handleConfirm}
            />
          </>
        }
      />
    </>
  );
};

PhotoRemoveAllButton.propTypes = {
  disabled: PropTypes.bool,
  finish: PropTypes.object,
  multipleFinishesPerOrder: PropTypes.bool,
};

PhotoRemoveAllButton.defaultProps = {
  disabled: true,
  finish: null,
  multipleFinishesPerOrder: false,
};

export default PhotoRemoveAllButton;
